export default __webpack_public_path__ + "static/media/breakfast-overlay@3x.c8a84090.png";